import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RoutingService } from '@skylab-angular-shared/core';
import { CompanyContextLink } from '@skylab-angular-shared/pipes';
import { TooltipDirective } from '@skylab-angular-shared/ui';
import { NavigationRoute } from '@skylab-shared/scenes';

export interface DocumentLinkDetailToDisplay {
    id: number;
    label: string;
    state: NavigationRoute | null;
    number: string;
}

@Component({
    selector: 'skl-document-links-details-hintbox',
    templateUrl: './document-links-details-hintbox.component.html',
    imports: [TooltipDirective, RouterLink, CompanyContextLink]
})
export class DocumentLinksDetailsHintbox {
    @Input() public links!: DocumentLinkDetailToDisplay[];

    public constructor(
        private readonly routingService: RoutingService
    ) {}

    public trackByLinkId(_: number, item: DocumentLinkDetailToDisplay) {
        return item.id;
    }

    public getRoute(link: DocumentLinkDetailToDisplay): NavigationRoute | null {
        if (!link.state) return null;
        return {
            url: link.state.url,
            params: link.state.params
        };
    }

    public onHrefClick(event: MouseEvent, link: DocumentLinkDetailToDisplay): void {
        if ((link.state?.url === this.routingService.currentState.url) && !event.ctrlKey) {
            event.preventDefault();
            event.stopPropagation();

            this.routingService.setQueryParamsAsync(link.state.params || {}).then(() => {
                this.routingService.reloadCurrentState();
            });
        }
    }

    public close(): void {
        const event = new CustomEvent('insBackdropTap');
        document.dispatchEvent(event);
    }
}
